import axios from "axios"

export const videoInstance = async (url, params) => {
  const instance = axios.create()
  delete instance.defaults.headers.common["Authorization"]
  try {
    document.body.style.cursor = "wait !important"
    const request = await instance.post(url, params)
    const { data } = request
    if (data.status) {
      document.body.style.cursor = "default  !important"
    }
    return request
  } catch (err) {
    if (!err?.response?.data?.status) {
      document.body.style.cursor = "not-allowed  !important"
      setTimeout(() => {
        document.body.style.cursor = "default  !important"
      }, 1000)
    }
    if (err?.response?.data) return err.response.data
    else return err.message
  }
}

export const videoInstanceDelete = async (url, params) => {
  const instanceDelete = axios.create()
  delete instanceDelete.defaults.headers.common["Authorization"]
  try {
    document.body.style.cursor = "wait !important"
    const request = await instanceDelete.post(url, { title: `${params}` })
    const { data } = request
    if (data.status) {
      document.body.style.cursor = "default  !important"
    }
    return request
  } catch (err) {
    if (!err?.response?.data?.status) {
      document.body.style.cursor = "not-allowed  !important"
      setTimeout(() => {
        document.body.style.cursor = "default  !important"
      }, 1000)
    }
    if (err?.response?.data) return err.response.data
    else return err.message
  }
}

export const videoInstanceCheck = async (url, params) => {
  const instanceDelete = axios.create()
  delete instanceDelete.defaults.headers.common["Authorization"]
  try {
    document.body.style.cursor = "wait !important"
    const request = await instanceDelete.post(url, { title: `${params}` })
    const { data } = request
    if (data.status) document.body.style.cursor = "default  !important"
    return request
  } catch (err) {
    if (!err?.response?.data?.status) {
      document.body.style.cursor = "not-allowed  !important"
      setTimeout(() => {
        document.body.style.cursor = "default  !important"
      }, 1000)
    }
    if (err?.response?.data) return err.response.data
    else return err.message
  }
}
